import { PixLogo as PixIcon } from "@phosphor-icons/react";

export default PixIcon
